var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactUsIconRectenggle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 178,
    height: 74,
    viewBox: "0 0 178 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contact_us4",
    transform: "translate(0 -4602)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153051",
    "data-name": "\\uC0AC\\uAC01\\uD615 153051",
    transform: "translate(0 4602)",
    fill: "none",
    stroke: "#d7e0ec",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153053",
    "data-name": "\\uC0AC\\uAC01\\uD615 153053",
    transform: "translate(0 4626)",
    fill: "none",
    stroke: "#d7e0ec",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153052",
    "data-name": "\\uC0AC\\uAC01\\uD615 153052",
    transform: "translate(24 4602)",
    fill: "none",
    stroke: "#d7e0ec",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153054",
    "data-name": "\\uC0AC\\uAC01\\uD615 153054",
    transform: "translate(24 4626)",
    fill: "none",
    stroke: "#d7e0ec",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_173517",
    "data-name": "\\uADF8\\uB8F9 173517"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153059",
    "data-name": "\\uC0AC\\uAC01\\uD615 153059",
    transform: "translate(129 4602)",
    fill: "#f3e3a1",
    stroke: "#f3e3a1",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 20,
    height: 21,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153060",
    "data-name": "\\uC0AC\\uAC01\\uD615 153060",
    transform: "translate(152 4626)",
    fill: "none",
    stroke: "#d7e0ec",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153058",
    "data-name": "\\uC0AC\\uAC01\\uD615 153058",
    transform: "translate(101 4650)",
    fill: "none",
    stroke: "#d7e0ec",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153055",
    "data-name": "\\uC0AC\\uAC01\\uD615 153055",
    transform: "translate(48 4602)",
    fill: "none",
    stroke: "#d7e0ec",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_153056",
    "data-name": "\\uC0AC\\uAC01\\uD615 153056",
    transform: "translate(0 4650)",
    fill: "#1876d2",
    stroke: "#1876d2",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsIconRectenggle1);
export default __webpack_public_path__ + "static/media/contact_us_icon_rectenggle1.a4b4748f5ac6468ca03fb7ac853987fc.svg";
export { ForwardRef as ReactComponent };